// 检查方块是否可以放置在指定位置
export const canPlaceBlock = (board, row, col, height, width) => {
  // 检查边界
  if (row < 0 || row + height > 8 || col < 0 || col + width > 8) {
    return false
  }

  // 检查是否有重叠
  for (let i = 0; i < height; i++) {
    for (let j = 0; j < width; j++) {
      if (board[row + i][col + j].blockId) {
        return false
      }
    }
  }

  return true
}

// 检查方块是否可以放置（忽略指定方块的占位，用于移动已放置方块）
export const canPlaceBlockIgnoring = (board, row, col, height, width, ignoreBlockId) => {
  if (row < 0 || row + height > 8 || col < 0 || col + width > 8) {
    return false
  }
  for (let i = 0; i < height; i++) {
    for (let j = 0; j < width; j++) {
      const cell = board[row + i][col + j]
      if (cell.blockId && cell.blockId !== ignoreBlockId) {
        return false
      }
    }
  }
  return true
}

// 放置方块
export const placeBlock = (board, row, col, block, blockId) => {
  const [height, width] = block.size
  
  for (let i = 0; i < height; i++) {
    for (let j = 0; j < width; j++) {
      board[row + i][col + j] = {
        color: block.color,
        blockId: blockId,
        preview: false
      }
    }
  }
}

// 移除方块
export const removeBlock = (board, row, col, height, width) => {
  for (let i = 0; i < height; i++) {
    for (let j = 0; j < width; j++) {
      board[row + i][col + j] = {
        color: 'empty',
        blockId: null,
        preview: false
      }
    }
  }
}

// 旋转方块
export const rotateBlock = (block) => {
  if (block.size[0] === block.size[1]) return false
  block.size = [block.size[1], block.size[0]]
  return true
}

// 深拷贝游戏板（避免浅拷贝导致的 Vuex 状态提前修改）
export const cloneBoard = (board) => {
  return board.map(row =>
    row.map(cell => ({ ...cell }))
  )
}

// 创建新的游戏板
export const createBoard = () => {
  const board = []
  for (let i = 0; i < 8; i++) {
    board[i] = []
    for (let j = 0; j < 8; j++) {
      board[i][j] = {
        color: 'empty',
        blockId: null,
        preview: false
      }
    }
  }
  return board
}

// 检查是否完成关卡
export const checkLevelComplete = (board) => {
  for (let i = 0; i < 8; i++) {
    for (let j = 0; j < 8; j++) {
      if (board[i][j].color === 'empty') {
        return false
      }
    }
  }
  return true
}

// 预览方块放置
export const previewBlockPlacement = (board, row, col, block) => {
  const [height, width] = block.size
  const canPlace = canPlaceBlock(board, row, col, height, width)
  
  if (!canPlace) return false

  for (let i = 0; i < height; i++) {
    for (let j = 0; j < width; j++) {
      if (!board[row + i][col + j].blockId) {
        board[row + i][col + j] = {
          color: block.color,
          blockId: null,
          preview: true
        }
      }
    }
  }
  
  return true
}

// 清除预览
export const clearPreview = (board) => {
  for (let i = 0; i < 8; i++) {
    for (let j = 0; j < 8; j++) {
      if (board[i][j].preview) {
        board[i][j] = {
          color: 'empty',
          blockId: null,
          preview: false
        }
      }
    }
  }
} 